module.exports = __webpack_public_path__ + "static/img/lucilas-1.28540bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/lucilas-1.jpg
// module id = 2sKn
// module chunks = 1